import { UNDERSTANDING_ERROR, UNDERSTANDING_HIDE_ERROR, UNDERSTANDING_SECTION, } from "@frameworks/web/redux/interfaces/Reports/iUnderstandingSection";
const initState = {
    data: { reportSummary: [], reportDetails: [] },
    errorData: { error: null, isOpen: false },
};
const understandSection = (state = initState, action) => {
    switch (action.type) {
        case UNDERSTANDING_SECTION:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case UNDERSTANDING_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case UNDERSTANDING_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: Object.assign(Object.assign({}, state.errorData), { isOpen: false }) });
        default:
            return Object.assign({}, state);
    }
};
export default understandSection;
